
    
 // ================================ 折扣后的数据 ================================================
 let afterDiscount = {
	"cartOrderVariantVos": [],
	"customerIdShop": 0,
  "totalDiscount": "",
  "properties": {}
  }
    // cart 获取
  let getCartInfo = []
  let getCustomInfo = []
   // =================================== 购物车接口 ==========================
    $.ajax({  
    type : "get",  
    url : "https://"+window.location.host+"/cart.js",  
    dataType:"text",
    async : false,
    success : function(data){  
      let total =  JSON.parse(data);
      console.log(total)
      getCustomInfo = total.items
      if(total.items) {
        total.items.map(items =>{
          getCartInfo.push({
            "currentPrice": null,
            "discountAmount": null,
            "finalPrice": items.final_price,
            "originalPrice": items.original_price,
            "quantity": items.quantity,
            "productIdShop": items.product_id,
            "variantIdShop": items.variant_id,
            "key": items.key
          })
        })
      }
    },
    error: function(err){
      alert("error")
    }
  })
// ======================================= 折扣价格===================================================
let tableTr = $(".cart-table_line-item"),
    tablePrice = "line-item_price",
    tableNum = "line-item_quantity",
    tableNumInput = ".quantityInput",
    tableNumMinus = ".quantityInput-minus"
    tableNumPlus = ".quantityInput-plus",
    tableTipSpan = "line-item_quantity span",
    tableNumWrap = ".line-item_quantity .quantity_sr",
    controlsSubmitCart = "controlsSubmitCart",
    popupTotal = "line-item_total-price", // 单条总价
    allTotal = "cart-summary_price", // 总价
    checkoutButton = "checkout-submit-button" // 提交按钮
  getCart()

  function getCart() {
     // 商品折扣后数据
    $.ajax({
      type: "post",
      url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/cartDiscount/getDiscount",
      data: JSON.stringify(getCartInfo),
      contentType: "application/json",
      dataType: "text",
      async: false,
      success: function(response) {
        afterDiscount.cartOrderVariantVos = [];
//         console.log(response)
        let variantDiscountVos = JSON.parse(response).variantDiscountVos;
        if(variantDiscountVos) {
          variantDiscountVos.map((getCon,i) =>{
            console.log("================单条价格=======================")
          	tableTr.eq(i).find("." + tablePrice).html(`
            <div class="${getCon.discount ? 'hide' : ''}">${getCon.originalPrices}</div>
            <div class="${getCon.discount ? '' : 'hide'}">
              <s>${getCon.originalPrices}</s>
              <p class="shopify-Price-amount amount">${getCon.currentPrice}</p>
              <p class="order-discount" style="font-size:12px;">discount: ${getCon.discountAmount}</p>
            </div>
          `)
              console.log("================提示不满足=======================")	
          	  tableTr.eq(i).find("." + tableTipSpan).remove()
              // ======================== 数量 ====================
              //input框
              tableTr.eq(i).find("."+ tableNum).html(`
                  <div class="input-group quantity_sr">
                    <quantity-input>
                      <input type="number" name="quantity" id="${getCon.key}" class="quantityInput"  readonly="" min="1" value="${getCon.quantity}" pattern="[0-9]+" inputmode="numeric">
                      <div class="qty-wrapper">
                        <quantity-input-plus class="cursor-pointer quantityInput-plus"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 37 64">
                          <path d="M35.2 28.8q1.92 0 1.92 3.2t-1.92 3.2h-13.44v13.44q0 1.92-3.2 1.92t-3.2-1.92v-13.44h-13.44q-1.92 0-1.92-3.2t1.92-3.2h13.44v-13.44q0-1.92 3.2-1.92t3.2 1.92v13.44h13.44z"></path></svg></quantity-input-plus>
                         <quantity-input-minus class="cursor-pointer quantityInput-minus"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 37 64">
                            <path d="M35.2 28.8q1.92 0 1.92 3.2t-1.92 3.2h-33.28q-1.92 0-1.92-3.2t1.92-3.2h33.28z"></path></svg></quantity-input-minus>
                        </div>
                      </quantity-input>
                    </div>
              `)
              console.log("================单条总价格=======================")
              tableTr.eq(i).find("." + popupTotal).html(`
              <div class="${getCon.discount ? 'hide' : ''}">${getCon.originalTotal}</div>
              <div class="${getCon.discount ? '' : 'hide'}">
              <s>${getCon.originalTotal}</s>
              <p class="shopify-Price-amount amount product-subtotal">${getCon.total}</p>
              </div>
              `)
            let cartVos= {
              "quantity":getCon.quantity,
              "productShopId": getCon.productIdShop,
              "variantIdShop": getCon.variantIdShop,
              "properties":getCon.properties
            }
            afterDiscount.cartOrderVariantVos.push(cartVos)

          })
          console.log("================总价格=======================", JSON.parse(response).totalOriginalPrice, JSON.parse(response).totalCurrentPrice)
          $("." + allTotal).html(`
            <span class="cart__popup-stotal">
              <s class=" " style="color: #6c757 !important">${JSON.parse(response).totalOriginalPrice}</s>
              <span class="">${JSON.parse(response).totalCurrentPrice}</span>
            </span>
          `)
          //================提交按钮=======================
          $("#" + checkoutButton).addClass('hide')
          $("." + controlsSubmitCart).remove()
          $("#" + checkoutButton).before(`<button class="controlsSubmitCart class_none_bundle checkout-button button btn w-100">Proceed to checkout</button>`)

          //======s==========商品折扣后数据==============s=========
          afterDiscount.customerIdShop = ""
          if(__st.cid) {
            afterDiscount.customerIdShop = __st.cid
          } 
          afterDiscount.totalDiscount = JSON.parse(response).totalDiscount

        }
      },
      error: function(err) {
        console.log(err)
      }
    });
  
  }
//加减
$(document).on("click",tableNumPlus,function() {
  let that= this,sGetVal = Number($(that).parent(".qty-wrapper").siblings(tableNumInput).val());
  tableTr.each(function(eq) {
    if($(this).find($(tableNumInput)).attr("id") == $(that).parent(".qty-wrapper").siblings(tableNumInput).attr("id")) {
      getCartInfo[eq].quantity = sGetVal
      getCart()
    }
  })
})
$(document).on("click",tableNumMinus,function() {
  let that= this,sGetVal = $(that).parent(".qty-wrapper").siblings(tableNumInput).val();
  if(sGetVal<= 1) {
  	sGetVal = 1
  } else {
    sGetVal = Number($(that).parent(".qty-wrapper").siblings(tableNumInput).val())
  }
  tableTr.each(function(eq) {
    if($(this).find($(tableNumInput)).attr("id") == $(that).parent(".qty-wrapper").siblings(tableNumInput).attr("id")) {
      getCartInfo[eq].quantity = sGetVal
      getCart()
    }
  })
})
 // 结算
  $(document).on("click","." + controlsSubmitCart,function() {
    $.ajax({
        type: "post",
        url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/cartDiscount/addDraftOrder",
        data: JSON.stringify(afterDiscount),
        contentType: "application/json",
        dataType: "text",
        async: false,
        success: function(response) {
          if(JSON.parse(response).success) {
            window.location.href = JSON.parse(response).url
          } else {
            $("." + tableTipSpan).remove()
            // 判断是否符合要求
            JSON.parse(response).orderResultVariantVos.map((getMinNum,minI) =>{
              // tableTr.eq(minI).find(tableNumWrap).after(`<span style="font-size:12px;color:red;display:block;">${getMinNum.message}</span>`)
              if(getMinNum.variantIdShop == afterDiscount.cartOrderVariantVos[minI].variantIdShop) {
                if(!getMinNum.moqCondition){
                  tableTr.eq(minI).find(tableNumWrap).after(`<span style="font-size:12px;color:red;display:block;">${getMinNum.message}</span>`)
                }
              }
            })
          }
        },
        error: function(err) {
          console.log(err)
        }
      });
    
  });
    